import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'

//var dateFormat = require('dateformat');


const RenderWpForm = () => {
var md5 = require('md5');
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");	

//var boolFetchingSads=false;

const navigate = useNavigate();

const [progress, setProgress] = useState({
perct:null
});
const [selectedFiles, setSelectedFiles] = useState([]);
const [dowait, setDowait] = useState({show:false});
const [myprofile, setMyprofile] = useState({password1:"", password2:""});
const [caseworkers, setCaseworkers] = useState([]);
const [combolocation, setCombolocation] = useState([]);
const [comboprocessarea, setComboprocessarea] = useState([]);
const [trusteddevices, setTrusteddevices] = useState([]);
const [pwd, setPwd] = useState({
	req1:false
	,req2:false
	,req3:false
	,req4:false
	,req5:false
	,req6:false
	});


/*IRD_LOGIN_ID:''
, EMPL_COMPANY:''*/
let trusteddevicesfetched=false;

const location = useLocation();


useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	
	
document.title =   "APS My Profile";	
getcaseworkers();

 },[]);



useEffect(() => {
	
	if (pwd.req1 && pwd.req2 && pwd.req3 && pwd.req4 && pwd.req5)
		document.getElementById("btnpwd").style.visibility="visible";
	else
		document.getElementById("btnpwd").style.visibility="hidden";
	
 },[pwd]);
 
useEffect(() => {
	//trusteddevices
	//console.log('myprofile: '+JSON.stringify(myprofile));
	
	if (myprofile.EMAIL!=""){
		if (trusteddevicesfetched==false)
			gettrusteddevices();
		}//end if
 },[myprofile]);

useEffect(() => {
	checkpassword();
 },[myprofile.password1,myprofile.password2]);



useEffect(() => {
	if (caseworkers.length>0)
		getloginprofile();
 },[JSON.stringify(caseworkers)]);


useEffect(() => {
	if (myprofile.USERNAME!="")
		getwpformoptions();
 },[myprofile]);

async function updatepassword(){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {email:sessionStorage.getItem("USERNAME"), pwd:md5(myprofile.password1)} )
  };		

  await fetch(resturl+'rarwplogin/updatepassword',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatepassword(res) )
      .catch(err => console.log(err));

}//end func

function afterupdatepassword(res){
	let EMAIL_COUNT=0;
	if (res.length)
		if (res.length==1)
			EMAIL_COUNT=res[0].EMAIL_COUNT;

if (EMAIL_COUNT==0)
	showsnackbar("that failed!");
else
	showsnackbar("done!");

}//end func
async function gettrusteddevices(){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {EMAIL:sessionStorage.getItem("USERNAME")} )
  };		

  await fetch(resturl+'rarwplogin/gettrusteddevices',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettrusteddevices(res) )
      .catch(err => console.log(err));

}//end func



function aftergettrusteddevices(res){
	
trusteddevicesfetched=true;
if (!res.length)
	return;
let temp=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key="trustdevice_"+index;
	
	temp.push(<option key={key} value={col['DEVICE']}  >{col['DEVICE']}</option>);

	});//end map	

setTrusteddevices(temp)	;


}//end func

async function getwpformoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		

  await fetch(resturl+'rarwpform/getwpformoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwpformoptions(res) )
      .catch(err => console.log(err));

}//end func


function aftergetwpformoptions(res){

let templocation=[];
let tempprocessarea=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	const val=col['VAL'];
	const strOption=""+opt;

	if (combo=='location' && !strOption.toUpperCase().includes("UNKNOWN"))
		templocation.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='processarea')
		tempprocessarea.push(<option key={key} value={opt}  >{opt}</option>);
	
	});//end map
setCombolocation(templocation);
tempprocessarea.push(<option key="processareaGovt" value="Government"  >Government</option>);
setComboprocessarea(tempprocessarea);

}//end func

async function handleDeviceChange(e){
	
const DEVICE=e.target.value;
const confirmed = window.confirm("remove "+DEVICE+" from your list of trusted devices?");

if (!confirmed)
	return;

const params={
	LOGIN_NAME: sessionStorage.getItem("USERNAME")
	, DEVICE: DEVICE
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };	
  
	
  await fetch(resturl+'rarwplogin/untrustdevice',requestOptions)
      .then(res => res.json())
      .then(res => 	{afteruntrustdevice(res);  } )
      .catch(err => console.log(err));
	
}//end func


function afteruntrustdevice(res){
showsnackbar('done!');
}//end func
	
	
function aftersetcaseworker(res){
setDowait({show:false});
showsnackbar('the changes were saved');
}//end func
	
async function setcaseworker(){
	
	//const EMPL_COMPANY=document.getElementsByName('EMPL_COMPANY')[0].value;
	console.log("setcaseworker myprofile: "+JSON.stringify(myprofile));
	
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {EMAIL:sessionStorage.getItem("USERNAME"), myprofile:myprofile} )
  };	
	
	setDowait({show:true});
	if (!document.getElementById("btnsave").classList.contains("hidden"))
		document.getElementById("btnsave").classList.add("hidden");

	
  await fetch(resturl+'rarwpform/setcaseworker',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersetcaseworker(res) )
      .catch(err => console.log(err));

}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function getcaseworkers(res){
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify(  )
  };	
	
  fetch(resturl+'rarwpform/getcaseworkers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetcaseworkers(res) )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftergetcaseworkers(res){
	
let tempcw=[];

res.map((col, index) => {
	const key="cw_"+index;
	const opt=col['FULLNAME'];
	//the value of combo is integer in 2 cases: MPE_OCCUPATIONID and AGENCY_ID
	const val=col['USERNAME'];
	
	tempcw.push(<option key={key} value={val}  >{opt}</option>);
	
	});	
	
	setCaseworkers(tempcw)
}//end func

function getloginprofile(){
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME")} )
  };	
	
  fetch(resturl+'rarwpform/getloginprofile',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetloginprofile(res) )
      .catch(err => console.log(err));

	//console.log('aftergetwpapp: '+res[0].OCCUPATION);
}//end func

function aftergetloginprofile(res){
//const IRD_LOGIN_ID=(res.length>0)?res[0].IRD_LOGIN_ID:'';
if (!res.length){
	console.log("abort aftergetloginprofile: res.length absent ")
	}
console.log('aftergetloginprofile: '+JSON.stringify(res[0]));
const datarow=res[0];
let datas=myprofile;
	for(var attributename in datarow)
		datas[attributename]=datarow[attributename]??"";

//console.log('datas: '+JSON.stringify(datas));

setMyprofile((prev)=>{
return {...prev	, datas	}
});
/*
		, EMPL_COMPANY:res[0].EMPL_COMPANY
		, CASE_WORKER:res[0].CASE_WORKER
		, FULLNAME:res[0].FULLNAME
		, EMAIL:res[0].EMAIL
		, USERNAME:res[0].USERNAME
		, PROCESS_AREA:res[0].PROCESS_AREA
		, TC_ISLAND:res[0].TC_ISLAND

*/
}//end func




async function uploadfiles(e){
	e.preventDefault();
	
	if (!e.target.classList.contains("hidden"))
		e.target.classList.add("hidden");
	
	console.log('uploadfiles: '+selectedFiles.length+', myprofile.WEB_USER_FOLDER: '+myprofile.WEB_USER_FOLDER);
	if (selectedFiles.length==0)
		return;
 const FormData = require('form-data'); // npm install --save form-data

const form = new FormData();

form.append('USERNAME', sessionStorage.getItem("USERNAME"));
form.append('REF_NUM', myprofile.WEB_USER_FOLDER);
form.append('PHOTO_FILE_NAME', "reginfo."+selectedFiles[0].ext);

//let formfiles={foto:false,sign:false,scans:false};

const currfile=selectedFiles[0].file;
const ext=selectedFiles[0].ext;
let scansFile=new File([currfile], 'reginfo.'+ext);
const filenames={scans:currfile.name};

form.append('REG_INFO', filenames.scans);

if (scansFile!=null)	{form.append('filesupload', scansFile);}

const request_config = {
    onUploadProgress: data => {
      //Set the progress value to show the progress bard
      setProgress({perct:Math.round((100 * data.loaded) / data.total)});
    },
};
await axios.post(resturl+'rarwpform/uploadregphotofile', form, request_config)
.then(res => afteruploadfiles(e, res.data));

	
}//end func

function afteruploadfiles(e, data){
/*
	if (e.target.classList.contains("hidden"))
		e.target.classList.remove("hidden");
*/

showsnackbar("done!");
setMyprofile((prev)=>{
	return {...prev, PHOTO_PATH: ""}
});
getloginprofile();
//if (document.getElementById("imgphoto")){
	//const ext=selectedFiles[0].ext;
	//document.getElementById("imgphoto").src="";
	//document.getElementById("imgphoto").src=resturl+"rarwpform/getwebuserfoto?path="+myprofile.PHOTO_PATH;
//	}//end if

/*
	setMyprofile((prev)=>{
		return {...prev, PHOTO_PATH: PHOTO_PATH}
	});

*/
}//end func


function checkpassword() {
  var strength = 0;
  /*
  len, capital, common, number, match
  */
  const pwd1=(""+myprofile.password1).trim();
  const pwd2=(""+myprofile.password2).trim();
  //console.log("pwd1: "+pwd1);Holiday1
  //console.log("pwd2: "+pwd2);
  setPwd((prev)=>{
	  return {...prev
	  , req1: pwd1.length>7 && pwd1.length<31
	  , req2: pwd1.match(/[A-Z]+/)
	  , req3: pwd1.match(/[a-z]+/)
	  , req4: pwd1.match(/[0-9]+/)
	  , req5: (pwd1!="" && pwd1==pwd2)
	  }
  });
  
  
/*
  if (myprofile.password1.match(/[a-z]+/)) {
    strength += 1;
  }
  if (myprofile.password1.match(/[A-Z]+/)) {
    strength += 1;
  }
  if (myprofile.password1.match(/[0-9]+/)) {
    strength += 1;
  }
  if (myprofile.password1.match(/[$@#&!]+/)) {
    strength += 1;

  }
  if (myprofile.password1.length < 6) {
   // display.innerHTML = "minimum number of characters is 6";
  }

  if (myprofile.password1.length > 12) {
  //  display.innerHTML = "maximum number of characters is 12";
  }	
	*/


}//end func

function handleChange(e){
	const {name, value}=e.target;
//console.log("handleChange name: "+name+" -> "+value);	
//document.getElementById('btnsave').style.visibility='visible';
setMyprofile((prev)=>{
	return {...prev, [name]:value}
});

if (document.getElementById("btnsave").classList.contains("hidden"))
	document.getElementById("btnsave").classList.remove("hidden");

}//end func

function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func


function selectedFilesChange(event){

if (event.target.files.length>1){
	showsnackbar("upload only one file please");
	return;
	}
else if (event.target.files.length==0)
	return;
	
const fileName=event.target.files[0].name;
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);

const lsExtension="png, jpg, jpeg, bmp, webp, gif";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementById("regfile").value='';
	showsnackbar("error: the uploaded file must have one of these extensions: "+lsExtension);
	return;
	}//end if		


	let temp=selectedFiles;
	temp[0]={file:event.target.files[0], ext:fileExtension};
	setSelectedFiles(temp);
	if (temp[0].file)
		if (document.getElementById("btnuploadfiles").classList.contains("hidden"))
			document.getElementById("btnuploadfiles").classList.remove("hidden");
	
	
}//end func


const TRUSTED_DEVICE=sessionStorage.getItem("TRUSTED_DEVICE");

function nofunc(){
}
  return (
    <>
	<fieldset className="fieldsetlg" style={{width:"45%",marginTop:"12px"}} >
	<legend>Profile Information is below</legend>
	
	<table align='center'>
	<tbody>
	<tr>
	<td align='right' >Username: </td>
	<td align='left' >{sessionStorage.getItem("USERNAME")}</td>
	</tr>
	<tr>
	<td align='right' >Email: </td>
	<td align='left' >{sessionStorage.getItem("NEW_EMAIL")}</td>
	</tr>
	<tr>
	<td align='right' >Roles: </td>
	<td align='left' >{sessionStorage.getItem("NUM_ROLES")}</td>
	</tr>	
	{
	myprofile.IRD_LOGIN_ID!=null && myprofile.IRD_LOGIN_ID!="" &&
	<tr>
	<td align='right' >Voucher Creation Username: </td>
	<td align='left' >{myprofile.IRD_LOGIN_ID}</td>
	</tr>
		
	}
	
	<tr>
	<td align='right' >Full Name: </td>
	<td align='left' ><input name='FULLNAME' autoComplete="off" defaultValue={myprofile.FULLNAME} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} /></td>
	</tr>
	<tr>
	<td align='right' >Agency: </td>
	<td align='left' ><input name='AGENCY' autoComplete="off" defaultValue={myprofile.AGENCY} readOnly className="gnsbro" onFocus={(e)=>{e.target.select();}}  /></td>
	</tr>
	<tr>
	<td align='right' >Case Worker: </td>
	<td align='left' >
		<select name='CASE_WORKER'  value={myprofile.CASE_WORKER} onChange={(e)=>{handleChange(e);}} >
		<option value='' ></option>
		{caseworkers}
		</select>
	</td>
	</tr>
	<tr>
		<td align='right' >Default Location:</td>
		<td align='left' >
			<select name='TC_ISLAND' required  value={myprofile.TC_ISLAND} onChange={ (e)=>{handleChange(e);} } >
			<option value='' ></option>
			{combolocation}
			</select>
		</td>
	</tr>	
	<tr>
		<td align='right' >Default Processing Area:</td>
		<td align='left' >
			<select name='PROCESS_AREA' required  value={myprofile.PROCESS_AREA} onChange={ (e)=>{handleChange(e);} } >
			<option value='' ></option>
			{comboprocessarea}
			</select>
		</td>
	</tr>	
	<tr>
		<td align='right' >{trusteddevices.length} Trusted Device(s):</td>
		<td align='left' >
			<select name='DEVICES' size="4" value={TRUSTED_DEVICE} style={{width:"150px"}} onChange={ (e)=>{handleDeviceChange(e);} } >
			<option value='' ></option>
			{trusteddevices}
			</select>
		</td>
	</tr>	
	<tr>
	<td align='right' ><a href="#" onClick={(e)=>{e.preventDefault(); toggleModalsm();document.getElementsByName("password1")[0].focus();}} >reset password</a></td>
	<td align='left' >
	{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
	{
	!dowait.show && 
	<button className='button hidden' id='btnsave'  onClick={(e)=>{setcaseworker();}}  >save changes</button>
	}	
	
	</td>
	</tr>

			<tr>
			<td align='right' >Approved/Refused date: </td>
			<td align='left' ><input defaultValue={myprofile.DECISION_DATE} onChange={(e)=>{handleChange(e);}} readOnly className="gnsbro"  /></td>
			</tr>
			<tr>
			<td align='right' >Photo Path: </td>
			<td align='left' ><input defaultValue={myprofile.PHOTO_PATH} onChange={(e)=>{handleChange(e);}} readOnly className="gnsbro"  /></td>
			</tr>
			<tr>
			<td colspan="2" align='center' >
			{
				myprofile.PHOTO_PATH && 
			<img id="imgphoto" src={resturl+"rarwpform/getwebuserfoto?path="+myprofile.PHOTO_PATH} border='0' height="280" />
			}
			{
			/*
			https://borderforceapps.gov.tc/rarwpform/getwebuserfoto?path=001133/reginfo.png
			https://borderforceapps.gov.tc/rarwpform/getmyprofilefoto?path=000125/reginfo.jpg
			resturl+"rarwpform/getmyprofilefoto?path="+myprofile.PHOTO_PATH
			*/}
			</td>
			</tr>
			{
			(myprofile.DECISION_DATE??"")=="" && 
				<>
				<tr>
				<td align='center' colSpan="2" ><input  type="file" name='regfile' id='regfile' accept=".png,.jpg,.jpeg,.bmp,.webp,.gif" required onChange={(e)=>{selectedFilesChange(e);}}  /></td>
				</tr>
				<tr>
				<td>&nbsp;</td>
				<td align='center' >
					<button onClick={(e)=>{uploadfiles(e);}} id="btnuploadfiles" className="button hidden" >upload id document</button>
				</td>
				</tr>
				</>
			}
			

		{sessionStorage.getItem("USERNAME")=="ajones" && <>
		<tr>
		<td align='right' >Rest URL: </td>
		<td align='left' >{sessionStorage.getItem("RESTURL")}</td>
		</tr>
		</>
		}
	</tbody>
	</table>
	</fieldset>
		{/*buttonstate.clicked && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
		{
		!buttonstate.clicked && 
		<input type="button" id='btnsubmitapp' className="button" value="application summary review and submit" onClick={(e)=>{ e.preventDefault(); navWpsummary.current?.click(); }}  />
		
		*/}


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div  id='modalsmtext' >
		<div align="left" >
		please note the password requirements:
		<br/>(i)  The password length is between 8 and 30 &nbsp;{pwd.req1 && <img src="img/greentick.png" height="14" border="0" />}
		<br/>(ii)  The password contains at least 1 Capital letter &nbsp;{pwd.req2 && <img src="img/greentick.png" height="14" border="0" />}
		<br/>(ii)  The password contains at least 1 Common letter &nbsp;{pwd.req3 && <img src="img/greentick.png" height="14" border="0" />}
		<br/>(iii)  The password contains at least 1 number &nbsp;{pwd.req4 && <img src="img/greentick.png" height="14" border="0" />}
		<br/>(iv)  The two inputs contain the same password &nbsp;{pwd.req5 && <img src="img/greentick.png" height="14" border="0" />}
		{/*<br/>(iv)  The password contains at least 1 of these special characters: $@#&!*/}
		</div>
		<table align="center">
		<tbody>
		<tr>
			<td align="right" >enter password:</td>
			<td align="left" ><input name="password1" type="password" value={myprofile.password1} onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}} /></td>
		</tr>
		<tr>
			<td align="right" >re-enter password:</td>
			<td align="left" ><input name="password2" type="password" value={myprofile.password2} onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}}  onPaste={(e)=>{e.preventDefault();}} /></td>
		</tr>
		<tr>
			<td align="right" >&nbsp;</td>
			<td align="left" ><button className="button" id="btnpwd" style={{visibility:"hidden"}} onClick={(e)=>{updatepassword();}} >save the password</button></td>
		</tr>
		</tbody>
		</table>
		</div>
		
    </div>
</div>	


<div id="snackbar">&nbsp;</div>
    
	
	</>
  );
  


};


export default RenderWpForm;